import { useState } from "react";
import QuestionCard from "../QuestionCard/QuestionCard";
import classes from "./QuestionBox.module.css";

const QuestionBox = ({
  number,
  letter = "Q",
  question,
  children,
  singleInput,
  groupedInput, // NEW
  multilineInput,
  placeholder,
  value,
  onChange,
  answers = [""],
  onAnswersChange,
  className,
  showEmptyNumber = true,
  showQuestion = true,
  addWidth,
  disabled
}) => {
  const handleAddAnswer = () => {
    const newAnswer = groupedInput ? { serial: "", testName: "", tat: "" } : "";
    const updatedAnswers = [...answers, newAnswer];
    onAnswersChange && onAnswersChange(updatedAnswers);
  };

  const handleChange = (index, keyOrValue, valueIfGrouped) => {
    const updatedAnswers = [...answers];

    if (groupedInput) {
      updatedAnswers[index][keyOrValue] = valueIfGrouped;
    } else {
      updatedAnswers[index] = keyOrValue;
    }

    onAnswersChange && onAnswersChange(updatedAnswers);
  };

  return (
    <div className={`${classes.wrapper} ${className} d-flex gap-2`}>
      {(letter || number) ? <div className={addWidth ? classes.numberContainer : ""}>
        <h5>{letter}{number}.</h5>
      </div> : showEmptyNumber && <div className={addWidth ? classes.numberContainer : classes.emptyNumber}/>}
      <div className="d-flex flex-column gap-2 w-100">
        {showQuestion && <QuestionCard question={question} />}
        {children}

        {/* Single Input Mode */}
        {singleInput && (
          <div className={classes.answerContainer}>
            {answers.map((answer, index) => (
              <input
                key={index}
                placeholder={`${index + 1}. Enter Item`}
                value={answer}
                onChange={(e) => handleChange(index, e.target.value)}
                className={classes.input}
                disabled={disabled}
              />
            ))}
            <div
              className={classes.addButton}
              role="button"
              onClick={() => !disabled && handleAddAnswer()}
            >
              Add new list item
            </div>
          </div>
        )}

        {/* Grouped Input Mode */}
        {groupedInput && (
          <div className={`${classes.answerContainer} mb-4`}>
            {answers.map((answer, index) => (
              <div key={index} className="d-flex gap-2 mb-2">
                <input
                  placeholder="Serial number"
                  value={answer.serial}
                  onChange={(e) =>
                    handleChange(index, "serial", e.target.value)
                  }
                  className={classes.input}
                  disabled={disabled}
                />
                <input
                  placeholder="Test name"
                  value={answer.testName}
                  onChange={(e) =>
                    handleChange(index, "testName", e.target.value)
                  }
                  className={classes.input}
                  disabled={disabled}
                />
                <input
                  placeholder="TAT (Day(s))"
                  value={answer.tat}
                  onChange={(e) => handleChange(index, "tat", e.target.value)}
                  className={classes.input}
                  disabled={disabled}
                />
              </div>
            ))}
            <div
              className={classes.addButton}
              role="button"
              onClick={() => !disabled && handleAddAnswer()}
            >
              Add new item
            </div>
          </div>
        )}

        {/* Multiline Input Mode */}
        {multilineInput && (
          <div className={classes.answerContainer}>
            <textarea
              placeholder={placeholder || "Write your response"}
              value={value}
              onChange={onChange}
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionBox;